import { gql } from '@apollo/client';
const GET_PRODUCT_CERTIFICATES = gql `
  query GetProductCertificates($first: Int = 25, $after: String = "") {
    autocomplete {
      productCertificates(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_CERTIFICATES;
